import type { components } from '@copilot/shared-types';
import { httpClient } from '../../shared/http/client';
import type { DashboardPeriod } from '../../shared/data/queryKeys';

export type DashboardStats = components['schemas']['DashboardStats'];

export async function getDashboardStats(period: DashboardPeriod): Promise<DashboardStats> {
  const response = await httpClient.get<DashboardStats>('/api/v1/dashboard/stats', {
    params: { period },
  });
  return response.data;
}
